import { Common, color } from '@stockbit/ui';
import { useState, useEffect, useRef } from 'react';
import Image from 'global/Image';
import { ButtonDropdownTrigger, DropdownWrapper } from '../styled';
import DropdownContent from './DropdownContent';
import CompanyIcon from './components/CompanyIcon';
import { StockCount } from './styled';
import { useFilterStore } from '../../store';
import { StockFilterTypeEnum } from '../../types';

const { Text, Flex } = Common;

interface StocksFilterProps {
  isMarketOpen: boolean;
}

const StocksFilter = ({
  isMarketOpen,
}: StocksFilterProps) => {
  const popoverRef = useRef(null);
  const popoverButtonRef = useRef(null);
  const [visible, setVisible] = useState(false);

  const selectedStockFilter = useFilterStore((s) => s.stocksFilter);

  const handleClickOutside = (event) => {
    if (popoverButtonRef.current?.contains(event.target)) return;
    if (popoverRef.current && !popoverRef.current.contains(event.target)) {
      setVisible(false);
    }
  };

  useEffect(() => {
    if (visible) {
      document.addEventListener('click', handleClickOutside);
    } else {
      document.removeEventListener('click', handleClickOutside);
    }

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [visible]);

  return (
    <div>
      <ButtonDropdownTrigger
        onClick={() => setVisible(!visible)}
        isOpened={visible}
        ref={popoverButtonRef}
      >
        {selectedStockFilter?.type === StockFilterTypeEnum.Custom && (
          <>
            {selectedStockFilter?.selected?.length === 1 && (
              <>
                <Flex align="center" style={{ gap: 4 }}>
                  <CompanyIcon symbol={selectedStockFilter?.selected[0].split('#')[0]} />
                  <Text size="12px">{selectedStockFilter?.selected[0].split('#')[0]}</Text>
                </Flex>
              </>
            )}
            {selectedStockFilter?.selected?.length > 1 && (
              <>
                <Flex align="center" style={{ gap: 4 }}>
                  <StockCount>
                    <Text size="13px" color={color.primary}>
                      {selectedStockFilter?.selected?.length}
                    </Text>
                  </StockCount>
                  <Text size="12px">Stocks</Text>
                </Flex>
              </>
            )}
          </>
        )}
        {selectedStockFilter?.type === StockFilterTypeEnum.AllStock && (
          <Text size="12px" ml="12px">All Stocks</Text>
        )}
        {selectedStockFilter?.type === StockFilterTypeEnum.Watchlist && (
          <Text
            size="12px"
            ml="12px"
            style={{ maxWidth: 87 }}
            ellipsis
          >
            {selectedStockFilter?.watchlistName}
          </Text>
        )}
        <Image src="/icon/chevron-down.svg" id="rt-filter-chevron-down" />
      </ButtonDropdownTrigger>
      {visible && (
        <DropdownWrapper ref={popoverRef}>
          <DropdownContent
            isMarketOpen={isMarketOpen}
            onClosePopover={() => setVisible(false)}
          />
        </DropdownWrapper>
      )}
    </div>
  );
};

export default StocksFilter;
